import { alpha, SxProps, Theme } from '@mui/material/styles';

/** Shared look for the rounded header controls (Figma "pill" chips). */
export const PILL_RADIUS = '100px';
export const PILL_MIN_HEIGHT = 40;

// Neutral chip surface that adapts to light/dark instead of a fixed grey.
export const pillBg = (theme: Theme): string => alpha(theme.palette.text.primary, 0.05);
export const pillBgHover = (theme: Theme): string => alpha(theme.palette.text.primary, 0.1);
export const pillBorder = (theme: Theme): string => alpha(theme.palette.text.primary, 0.12);

/** MUI Select styled like the header language picker (pill, no outline). */
export const pillSelectSx: SxProps<Theme> = {
  height: PILL_MIN_HEIGHT,
  minWidth: 0,
  color: 'text.primary',
  fontSize: '0.875rem',
  fontWeight: 500,
  borderRadius: PILL_RADIUS,
  bgcolor: pillBg,
  flexShrink: 0,
  cursor: 'pointer',
  '&:hover': { bgcolor: pillBgHover },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    pointerEvents: 'none',
  },
  // Caret: 16px from pill edge; 8px gap between label and arrow (24px icon).
  '& .MuiSelect-icon': {
    color: 'inherit',
    right: 16,
    pointerEvents: 'none',
  },
  '& .MuiSelect-select': {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: `${PILL_MIN_HEIGHT}px !important`,
    height: `${PILL_MIN_HEIGHT}px !important`,
    display: 'flex',
    alignItems: 'center',
    py: '0 !important',
    pl: '16px !important',
    pr: '48px !important',
  },
  '.MuiOutlinedInput-input': { color: 'inherit' },
};

/** Icon-only pill select (mobile language). */
export const pillSelectCompactSx: SxProps<Theme> = {
  ...pillSelectSx,
  width: PILL_MIN_HEIGHT,
  '& .MuiSelect-icon': { display: 'none' },
  '& .MuiSelect-select': {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: `${PILL_MIN_HEIGHT}px !important`,
    height: `${PILL_MIN_HEIGHT}px !important`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: '0 !important',
    pl: '0 !important',
    pr: '0 !important',
  },
};
